import { useState } from "react";
import { SearchSelect } from "../shared/searchSelect";
import { SearchFiltersModal } from "../shared/searchFiltersModal";
import stringHelpers from "../../utilities/stringHelpers";
import { TagSelector } from "../shared/tagSelector";
import appliedFiltersUtilities from "../../utilities/appliedFiltersUtilities";
import arrayUtilities from "../../utilities/arrayUtilities";

export const SitesFiltersModal = ({
	showModal,
	handleClose,
	handleConfirm,
	initialSelectedClient,
	initialSelectedTags,
	initialAppliedFilters,
	clients = [],
	tags = []
}) => {
	const [selectedClient, setSelectedClient] = useState(initialSelectedClient)
	const [selectedTags, setSelectedTags] = useState(initialSelectedTags)
	const [appliedFilters, setAppliedFilters] = useState(initialAppliedFilters)

	const clearLocalFilters = () => {
		setSelectedClient(null)
		setSelectedTags([])
		setAppliedFilters(null)
	}

	const handleTagsChange = tagSelections => {
		setSelectedTags(tagSelections)
		setAppliedFilters(prevState => appliedFiltersUtilities.applyMultiSelection(prevState, "Tags", tagSelections, tags))
	}

	return (
		<SearchFiltersModal
			title="Filter Results"
			handleClose={ handleClose }
			handleConfirm={ () => handleConfirm({ selectedClient, selectedTags, appliedFilters }) }
			showModal={ showModal }
			key="sites-filters-modal"
			handleReset={ clearLocalFilters }
		>
			<div className="w-100">
				<div className="d-flex flex-column mb-2">
					<label className="m-0 mr-2 mb-1 nowrap">Client</label>
					<SearchSelect
						defaultLabel="All"
						width="100%"
						options={ [{ value: "", label: "All" }, ...clients.map(item => ({ value: item.id, label: item.name }))] }
						onSelect={ value => {
							if (!stringHelpers.isNullOrEmpty(value)) {
								setSelectedClient(value)
								const client = clients.find(item => item.id === value)
								setAppliedFilters(prevState => ({ ...prevState, "Client": client.name }))
							} else {
								setSelectedClient(null)
								setAppliedFilters(prevState => {
									const updatedFilters = { ...prevState }
									delete updatedFilters["Client"]
									return Object.keys(updatedFilters).length > 0 ? updatedFilters : null
								})
							}
						} }
						selected={ !stringHelpers.isNullOrEmpty(selectedClient) ? selectedClient : null }
					/>
				</div>

				{ !arrayUtilities.isNullOrEmpty(tags) && <div className="d-flex flex-column mb-2">
					<div className="d-flex align-items-center justify-content-between">
						<label className="m-0 mr-2 mb-1 nowrap">Tags</label>
						<button onClick={() => handleTagsChange([])} className="btn btn-none m-0 p-0 fs--1 mb-1" type="button">Clear tags</button>
					</div>
					<TagSelector 
						onChange={ handleTagsChange }
						selectedTags={selectedTags}
						tags={tags}
					/>
				</div> }
			</div>
		</SearchFiltersModal>
	)
}
